<template>
  <div :class="`col-md-6 mb-3`">
    <div
      :class="[
        'card h-100 shadow-sm',
        type === 'today' ? 'today-card text-white' : 'performance-card',
      ]"
    >
      <div class="card-body">
        <h6
          :class="[
            'mb-3',
            type === 'today'
              ? 'font-weight-bold'
              : 'text-muted font-weight-bold',
          ]"
        >
          {{ title }}
        </h6>

        <div
          class="d-flex justify-content-between"
          v-if="type === 'performance'"
        >
          <div>
            <small class="text-uppercase text-muted">Total Balance</small>
            <h5 class="font-weight-bold text-white">
              MMK {{ formatNumber(data.total_balance) }}
            </h5>
          </div>
          <div class="text-right">
            <small class="text-uppercase text-muted">Company Profit(Total Win Lose Company)</small>
            <h5
              class="font-weight-bold"
              :class="
                data.total_win_lose_company < 0 ? 'text-danger' : 'text-success'
              "
            >
              MMK {{ formatNumber(data.total_win_lose_company) }}
            </h5>
          </div>
        </div>

        <div
          class="mt-3 d-flex justify-content-between"
          v-if="type === 'performance'"
        >
          <div>
            <small class="text-uppercase text-muted">Total Deposits</small>
            <p class="font-weight-bold mb-0">MMK {{ formatNumber(data.total_deposits) }}</p>
          </div>
          <div class="text-right">
            <small class="text-uppercase text-muted">Total Withdrawals</small>
            <p class="font-weight-bold mb-0">MMK {{ formatNumber(data.total_withdrawals) }}</p>
          </div>
        </div>

        <div
          class="d-flex justify-content-between text-white"
          v-if="type === 'today'"
        >
          <div>
            <small>New Registrations</small>
            <h5 class="font-weight-bold mb-0">
              {{ data.today_registered_users }}
            </h5>
          </div>
          <div class="text-right">
            <small>Deposits</small>
            <h5 class="font-weight-bold mb-0">MMK {{ formatNumber(data.today_deposits) }}</h5>
          </div>
        </div>

        <div
          class="mt-3 d-flex justify-content-between text-white"
          v-if="type === 'today'"
        >
          <div>
            <small>Withdrawals</small>
            <p class="font-weight-bold mb-0">MMK {{ formatNumber(data.today_withdrawals) }}</p>
          </div>
          <div class="text-right">
            <small>Bets</small>
            <p class="font-weight-bold mb-0">MMK {{ formatNumber(data.today_bet_amount) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true, // 'performance' or 'today'
    },
    data: {
      type: Object,
      required: true,
    },
    formatNumber:Function
  },
};
</script>

<style scoped>
.performance-card {
  background: #111827;
  color: #fff;
  border: none;
  border-radius: 10px;
}

.today-card {
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 10px;
}

.stat-card {
  border: none;
  border-radius: 10px;
  transition: transform 0.15s ease-in-out;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

h5 {
  font-size: 1.25rem;
}

small {
  font-size: 0.8rem;
  letter-spacing: 0.3px;
}
</style>
